// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"0e94cc21","643":"ed7b5d68"}[chunkId] + ".chunk.js";
};